// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://darkslateblue-bat-794836.hostingersite.com/",
});

export default axiosInstance;

export const weburl = "https://darkslateblue-bat-794836.hostingersite.com/";
// export const weburl = "https://manjit-jewellers-backend.onrender.com/";

export const Homeurl = "https://makeintern.servicekarwalo.com/";
export const adminurl = "https://makeintern.servicekarwalo.com/";
export const keyLogin = '6790eedec0468755d4a7a631';
export const LiveURL = 'https://secure.payu.in/_payment';
export const TestURL = 'https://indigo-raven-856234.hostingersite.com/';
export const Host = 'https://midnightblue-seal-752209.hostingersite.com/';

// export const weburl = 'https://backend-2o7f.onrender.com/';
